import BaseRequest from "./Base";

class UnAuthenticatedRequest extends BaseRequest { }

export default UnAuthenticatedRequest;



// WEBPACK FOOTER //
// ./src/services/requests/UnAuthenticated.js